import { render, staticRenderFns } from "./PageNft.vue?vue&type=template&id=640d9c47"
import script from "./PageNft.vue?vue&type=script&lang=js"
export * from "./PageNft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports